// extracted by mini-css-extract-plugin
module.exports = {"container":"value_container__16gbl"};